import { createContext, useContext, useState } from "react";

const ConsultContext = createContext(null);

export function ConsultProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <ConsultContext.Provider value={{ open, setOpen, openConsult: () => setOpen(true) }}>
      {children}
    </ConsultContext.Provider>
  );
}

export const useConsult = () => useContext(ConsultContext);
